module.exports = __webpack_public_path__ + "img/118.f8451ac7.gif";